import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */

const { Types, Creators } = createActions({
  getExperienceRequest: [],
  getExperienceSuccess: ['data'],
  getExperienceFailure: ['error'],
});

export const ExperienceTypes = Types;
export default Creators;

/* Initial State */

export const INITIAL_STATE = Immutable({
  experienceData: [],
  experienceError: {},
});

/* Reducers */

const getExperienceRequest = (state) =>
  state.merge({
    ...state,
    experienceError: {},
  });

const getExperienceSuccess = (state, { data }) =>
  state.merge({
    experienceData: data,
    experienceError: {},
  });

const getExperienceFailure = (state, { error }) =>
  state.merge({
    ...state,
    experienceError: { ...error },
  });

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_EXPERIENCE_REQUEST]: getExperienceRequest,
  [Types.GET_EXPERIENCE_SUCCESS]: getExperienceSuccess,
  [Types.GET_EXPERIENCE_FAILURE]: getExperienceFailure,
});
